import React from 'react';
import { isValueEmpty } from '@awp/helpers/utilsReact';

//Search input with a search button inside
//type "search" of input is not supported by firefox. This is the solution for all browsers
//Check DetailContainer for usage
//TO-DO property of props e.g. new css class
const AwpSearchBar = ({ ...props }) => {
  return (
    <div className="input-group" id={props.id}>
      <input
        type="text"
        id={props.id}
        className="form-control border-end-0 border-right-0 border"
        placeholder="Search..."
        value={props.value}
        onChange={(e) => props.onChange(e)}
      />
      <span className="input-group-append">
        {!isValueEmpty(props.value) && (
          <button
            className="btn btn-outline-secondary sm border-start-0 border-left-0 border-end-0 border-right-0 border"
            type="button"
            onClick={() => props.onRemove()}
          >
            <i className="fa fa-times" />
          </button>
        )}
        <button
          className="btn btn-outline-secondary sm border-start-0 border-left-0 border"
          type="button"
          onClick={() => props.onClick()}
        >
          <i className="fa fa-search" />
        </button>
      </span>
    </div>
  );
};

export default AwpSearchBar;
